const messageBubble = {
    backgroundColor: (isOwner, status) => {
        if (status === 'note') {
            return 'YELLOW_200';
        }
        if (isOwner) {
            return 'BLUE_200';
        }
        return 'INK_200';
    },
};
export default messageBubble;
//# sourceMappingURL=messageBubble.js.map